import { Box } from "@mui/material";
import { useSelector } from "react-redux";
import React from "react";
import { getCloudOrgStructureElement } from "slices/cloudOrgStructure";
import { createLookupRegistry, useLookupOnce } from "common/useLookupOnce";

const registry = createLookupRegistry();

const NiceCloudOrgElement = (props) => {
  const wantedResource = props.children;

  const element = useSelector((state) =>
    state.cloudOrgStructure?.data?.list?.find((org) => org.id === wantedResource)
  );

  useLookupOnce(
    registry,
    wantedResource,
    (id) => getCloudOrgStructureElement({ id }),
    { resolved: !!element, skip: wantedResource === "Cloud" }
  );

  return <>{element ? <Box>{element.name}</Box> : <Box>{wantedResource}</Box>}</>;
};

export default React.memo(NiceCloudOrgElement);
